import { Globals } from '../../modules/Globals';
import axios from 'axios';
import { ITranslation } from '../../interfaces/ITranslation';
import { IOrder } from '../../interfaces/IOrder';

const apiUrl = Globals.apiPath + '/translations';

export interface ITranslationData {
  id: number;
  languageId: string;
  outdated: boolean;
  name?: string;
  description?: string;
}

/** One language of a product or category translation, as the API reads it. */
export interface ITranslationEntryInput {
  languageId: string;
  name?: string | null;
  description?: string | null;
}

/** One option translation entry: optionItemId null targets the group itself. */
export interface IOptionTranslationEntry {
  optionItemId: number | null;
  languageId: string;
  title: string | null;
  description: string | null;
}

export default class TranslationsService {
  constructor() {}

  async getAll(restaurantId: number) {
    let res = await axios.get<ITranslation[]>(`${apiUrl}/r/${restaurantId}`);
    return res.data;
  }

  async getAllByItem(restaurantId: number, itemId: number) {
    let res = await axios.get<ITranslation[]>(
      `${apiUrl}/r/${restaurantId}/i/${itemId}`
    );
    return res.data;
  }

  async getAllByCategory(restaurantId: number, categoryId: number) {
    let res = await axios.get<ITranslation[]>(
      `${apiUrl}/r/${restaurantId}/c/${categoryId}`
    );
    return res.data;
  }

  async saveItemTranslations(
    restaurantId: number,
    itemId: number,
    entries: ITranslationEntryInput[],
    removedLanguageIds?: string[]
  ) {
    let res = await axios.post<ITranslation[]>(
      `${apiUrl}/r/${restaurantId}/i/${itemId}`,
      { entries, ...(removedLanguageIds?.length ? { removedLanguageIds } : {}) }
    );
    return res.data;
  }

  async saveCategoryTranslations(
    restaurantId: number,
    categoryId: number,
    entries: ITranslationEntryInput[],
    removedLanguageIds?: string[]
  ) {
    let res = await axios.post<ITranslation[]>(
      `${apiUrl}/r/${restaurantId}/c/${categoryId}`,
      { entries, ...(removedLanguageIds?.length ? { removedLanguageIds } : {}) }
    );
    return res.data;
  }

  async getOptionTranslations(restaurantId: number, optionId: number) {
    let res = await axios.get<ITranslation[]>(
      `${apiUrl}/r/${restaurantId}/o/${optionId}`
    );
    return res.data;
  }

  async saveOptionTranslations(
    restaurantId: number,
    optionId: number,
    entries: IOptionTranslationEntry[],
    removedLanguageIds?: string[]
  ) {
    let res = await axios.post<ITranslation[]>(
      `${apiUrl}/r/${restaurantId}/o/${optionId}`,
      { entries, ...(removedLanguageIds?.length ? { removedLanguageIds } : {}) }
    );
    return res.data;
  }
}
